export default __webpack_public_path__ + "static/media/bg-purple-waves-mid.3506c9d9.png";